import ConnectionSuccessfulWrapper from '../../components/ConnectionSuccessfulWrapper/ConnectionSuccessfulWrapper';
import { IonButton, IonCol, IonRow, useIonModal } from '@ionic/react';
import { useTranslation } from 'react-i18next';
import React from 'react';
import './ConnectionSuccessfulSubject.scoped.scss';
import { ParticipantIdSessionIdRequest, SessionIdRequest } from '../../models';
import { replace } from 'redux-first-history';
import { useSelector } from 'react-redux';
import { lookerSelector, resetAll, sessionIdSelector, subjectSelector } from '../../store/slices';
import { useParticipantReadyMutation, useSubjectCancelMutation } from '../../store/api';
import { useAppDispatch } from '../../store/store';
import WarningModal from '../../components/WarningModal/WarningModal';
import { OverlayEventDetail } from '@ionic/react/dist/types/components/react-component-lib/interfaces';
import { TYPE_SUBJECT } from '../../appConfigurations';

const ConnectionSuccessfulSubject: React.FC = () => {
  const { t } = useTranslation();
  const subject = useSelector(subjectSelector);
  const looker = useSelector(lookerSelector);
  const dispatch = useAppDispatch();
  const sessionId = useSelector(sessionIdSelector);
  const [participantReady] = useParticipantReadyMutation();
  const [subjectCancel] = useSubjectCancelMutation();

  const [present, dismiss] = useIonModal(WarningModal, {
    onDismiss: (data: string, role: string) => dismiss(data, role),
  });

  const openModal = (back: Function) => {
    present({
      onWillDismiss: async (ev: CustomEvent<OverlayEventDetail>) => {
        if (ev.detail.role === 'accept') {
          const response = await subjectCancel({
            sessionId: sessionId,
          } as SessionIdRequest).unwrap();
          if (response) {
            dispatch(resetAll());
            back();
          }
        }
      },
    });
  };

  const subjectReady = async () => {
    try {
      await participantReady({
        participantId: subject?.id,
        sessionId: sessionId,
      } as ParticipantIdSessionIdRequest);

      if (!looker?.ready) {
        dispatch(replace('/subject-ready'));
      } else {
        dispatch(replace('/get-ready-subject'));
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <ConnectionSuccessfulWrapper openModal={openModal} participantType={TYPE_SUBJECT}>
      <div className="connection-successful-subject">
        <IonRow>
          <IonCol className="who-is-connected-wrapper">
            <div className="who-is-connected looker-name">
              <div className="role">{t('Looker is connected')}</div>
            </div>
          </IonCol>
        </IonRow>
        <IonRow className="subtitle ion-text-center ion-no-padding ion-no-margin">
          <div>{t('Please turn your back to the Looker, relax and start the test.')}</div>
        </IonRow>
        <IonRow className="start-session-button ion-no-margin ion-no-padding">
          <IonButton className="secondary-type-button" onClick={subjectReady}>
            {t('Start Session')}
          </IonButton>
        </IonRow>
      </div>
    </ConnectionSuccessfulWrapper>
  );
};

export default ConnectionSuccessfulSubject;
